import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import { AdyenApplePayComponentDef } from '@df/module-adyen/apple-pay/adyen-apple-pay.component.def';
import { ResultComponent } from '../../../ui/api/result.component';
import { CheckoutFormComponent } from './../../../checkout/form/checkout-form.component';
import { CheckoutStepComponent } from './../../../checkout/step/checkout-step.component';
@Component({
    selector: 'adyen-apple-pay',
    templateUrl: './adyen-apple-pay.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ResultComponent]
})
export class AdyenApplePayComponent extends AdyenApplePayComponentDef {
    constructor(
        protected override checkoutFormComponent: CheckoutFormComponent,
        _ref: ChangeDetectorRef,
        protected override scrollToService: ScrollToService,
        protected checkoutStepcomponent: CheckoutStepComponent,
    ) {
        super(checkoutFormComponent,  _ref, scrollToService, checkoutStepcomponent);
    }
}
